import { render, staticRenderFns } from "./createCambio.vue?vue&type=template&id=0852b182&scoped=true&"
import script from "./createCambio.vue?vue&type=script&lang=js&"
export * from "./createCambio.vue?vue&type=script&lang=js&"
import style0 from "./createCambio.vue?vue&type=style&index=0&id=0852b182&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0852b182",
  null
  
)

export default component.exports